"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESCRIPTION_SKELETON = void 0;
const DESCRIPTION_SKELETON = exports.DESCRIPTION_SKELETON = 'description-skeleton';
